// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
  height: 100%;
}

.font-size-1 {
  font-size: 1px !important;
}

.font-size-2 {
  font-size: 2px !important;
}

.font-size-3 {
  font-size: 3px !important;
}

.font-size-4 {
  font-size: 4px !important;
}

.font-size-5 {
  font-size: 5px !important;
}

.font-size-6 {
  font-size: 6px !important;
}

.font-size-7 {
  font-size: 7px !important;
}

.font-size-8 {
  font-size: 8px !important;
}

.font-size-9 {
  font-size: 9px !important;
}

.font-size-10 {
  font-size: 10px !important;
}

.font-size-11 {
  font-size: 11px !important;
}

.font-size-12 {
  font-size: 12px !important;
}

.font-size-13 {
  font-size: 13px !important;
}

.font-size-14 {
  font-size: 14px !important;
}

.font-size-15 {
  font-size: 15px !important;
}

.font-size-16 {
  font-size: 16px !important;
}

.font-size-17 {
  font-size: 17px !important;
}

.font-size-18 {
  font-size: 18px !important;
}

.font-size-19 {
  font-size: 19px !important;
}

.font-size-20 {
  font-size: 20px !important;
}

.font-size-21 {
  font-size: 21px !important;
}

.font-size-22 {
  font-size: 22px !important;
}

.font-size-23 {
  font-size: 23px !important;
}

.font-size-24 {
  font-size: 24px !important;
}

.font-size-25 {
  font-size: 25px !important;
}

.font-size-26 {
  font-size: 26px !important;
}

.font-size-27 {
  font-size: 27px !important;
}

.font-size-28 {
  font-size: 28px !important;
}

.font-size-29 {
  font-size: 29px !important;
}

.font-size-30 {
  font-size: 30px !important;
}

.font-size-31 {
  font-size: 31px !important;
}

.font-size-32 {
  font-size: 32px !important;
}

.font-size-33 {
  font-size: 33px !important;
}

.font-size-34 {
  font-size: 34px !important;
}

.font-size-35 {
  font-size: 35px !important;
}

.font-size-36 {
  font-size: 36px !important;
}

.font-size-37 {
  font-size: 37px !important;
}

.font-size-38 {
  font-size: 38px !important;
}

.font-size-39 {
  font-size: 39px !important;
}

.font-size-40 {
  font-size: 40px !important;
}

.font-size-41 {
  font-size: 41px !important;
}

.font-size-42 {
  font-size: 42px !important;
}

.font-size-43 {
  font-size: 43px !important;
}

.font-size-44 {
  font-size: 44px !important;
}

.font-size-45 {
  font-size: 45px !important;
}

.font-size-46 {
  font-size: 46px !important;
}

.font-size-47 {
  font-size: 47px !important;
}

.font-size-48 {
  font-size: 48px !important;
}

.font-size-49 {
  font-size: 49px !important;
}

.font-size-50 {
  font-size: 50px !important;
}

.font-size-51 {
  font-size: 51px !important;
}

.font-size-52 {
  font-size: 52px !important;
}

.font-size-53 {
  font-size: 53px !important;
}

.font-size-54 {
  font-size: 54px !important;
}

.font-size-55 {
  font-size: 55px !important;
}

.font-size-56 {
  font-size: 56px !important;
}

.font-size-57 {
  font-size: 57px !important;
}

.font-size-58 {
  font-size: 58px !important;
}

.font-size-59 {
  font-size: 59px !important;
}

.font-size-60 {
  font-size: 60px !important;
}

.font-size-61 {
  font-size: 61px !important;
}

.font-size-62 {
  font-size: 62px !important;
}

.font-size-63 {
  font-size: 63px !important;
}

.font-size-64 {
  font-size: 64px !important;
}

.font-size-65 {
  font-size: 65px !important;
}

.font-size-66 {
  font-size: 66px !important;
}

.font-size-67 {
  font-size: 67px !important;
}

.font-size-68 {
  font-size: 68px !important;
}

.font-size-69 {
  font-size: 69px !important;
}

.font-size-70 {
  font-size: 70px !important;
}

.font-size-71 {
  font-size: 71px !important;
}

.font-size-72 {
  font-size: 72px !important;
}

.font-size-73 {
  font-size: 73px !important;
}

.font-size-74 {
  font-size: 74px !important;
}

.font-size-75 {
  font-size: 75px !important;
}

.font-size-76 {
  font-size: 76px !important;
}

.font-size-77 {
  font-size: 77px !important;
}

.font-size-78 {
  font-size: 78px !important;
}

.font-size-79 {
  font-size: 79px !important;
}

.font-size-80 {
  font-size: 80px !important;
}

.font-size-81 {
  font-size: 81px !important;
}

.font-size-82 {
  font-size: 82px !important;
}

.font-size-83 {
  font-size: 83px !important;
}

.font-size-84 {
  font-size: 84px !important;
}

.font-size-85 {
  font-size: 85px !important;
}

.font-size-86 {
  font-size: 86px !important;
}

.font-size-87 {
  font-size: 87px !important;
}

.font-size-88 {
  font-size: 88px !important;
}

.font-size-89 {
  font-size: 89px !important;
}

.font-size-90 {
  font-size: 90px !important;
}

.font-size-91 {
  font-size: 91px !important;
}

.font-size-92 {
  font-size: 92px !important;
}

.font-size-93 {
  font-size: 93px !important;
}

.font-size-94 {
  font-size: 94px !important;
}

.font-size-95 {
  font-size: 95px !important;
}

.font-size-96 {
  font-size: 96px !important;
}

.font-size-97 {
  font-size: 97px !important;
}

.font-size-98 {
  font-size: 98px !important;
}

.font-size-99 {
  font-size: 99px !important;
}

.font-size-100 {
  font-size: 100px !important;
}

body {
  margin: 0;
  font-family: "roboto" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: hsl(0, 0%, 92%) !important;
  color: hsl(217, 24%, 17%) !important;
}

a {
  color: hsl(240, 91%, 69%);
}
a:hover, a:focus {
  color: hsl(240, 91%, 69%);
}
a.no-underline {
  text-decoration: none;
}

.cursor-pointer {
  cursor: pointer;
}

.login {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  justify-content: center;
  padding-bottom: 2rem;
}
.login__header {
  position: absolute;
  top: 0;
  left: 32px;
  line-height: 72px;
  background-color: transparent;
  color: hsl(214, 4%, 31%);
  font-weight: 400;
  font-size: 24px;
  letter-spacing: 0.05em;
  color: #4C4F53;
}
.login form {
  margin: 0 auto;
  width: 100%;
}
.login form .login__input input#password::placeholder {
  color: hsl(217, 24%, 17%) !important;
  opacity: 1;
}
.login__title {
  display: flex;
  margin: 19px 0;
  align-items: center;
  justify-content: center;
}
@media screen and (max-device-width: 1200px) and (min-resolution: 100dpi) {
  .login__title {
    margin-bottom: 0.5rem;
  }
}
.login__title-text {
  font-size: 24px;
  color: hsla(217, 24%, 17%, 0.788);
  font-weight: bold;
}
.login__container {
  background-color: hsla(0, 0%, 100%, 0.43);
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  width: min(407px, 90vw);
  padding: 27px 38px 31px;
  border-radius: 20px;
  position: relative;
}
@media screen and (max-device-width: 1200px) and (min-resolution: 100dpi) {
  .login__container {
    padding: 1rem 1.5rem;
  }
}
.login__container .linear_progress {
  position: absolute;
  top: 0;
  left: 0;
  background-image: linear-gradient(89.91deg, rgba(220, 34, 255, 0.5) 12.07%, rgba(57, 161, 244, 0.5) 89.16%);
  margin-left: 1em;
  width: calc(100% - 2em);
  height: 0.15em;
}
.login__container .linear_progress .MuiLinearProgress-bar {
  background-color: hsl(0, 0%, 100%);
  width: 2em;
}
.login__container__title {
  display: flex;
  align-items: center;
  padding: 4px 8px;
  line-height: 45px;
  border-radius: 10px;
  font-size: 14px;
  background-color: hsl(0, 0%, 100%);
  cursor: pointer;
  font-weight: 500;
}
.login__container__title__google {
  font-size: 40px;
  display: flex;
  flex-basis: 35%;
}
.login__container__title__text {
  flex-basis: 75%;
}
.login__container__divider {
  color: hsl(217, 24%, 17%);
  padding: 30px 1.5rem 35px 1.5rem;
  position: relative;
  text-align: center;
  font-size: 14px;
}
.login__container__divider::after, .login__container__divider::before {
  content: "";
  border-top: 2px solid hsl(0, 0%, 100%) !important;
  position: absolute;
  width: 40%;
  top: 50%;
  transform: translateY(-50%);
}
.login__container__divider::before {
  left: 0;
}
.login__container__divider::after {
  right: 0;
}
@media screen and (max-device-width: 1200px) and (min-resolution: 100dpi) {
  .login__container__divider {
    padding: 0.25rem;
    font-size: 14px;
  }
}
.login__container__footer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 11px;
  margin-bottom: 19px;
  font-size: 12px;
}
@media screen and (max-device-width: 1200px) and (min-resolution: 100dpi) {
  .login__container__footer {
    margin-bottom: 0.25rem;
  }
}
.login__container__footer.forgot {
  margin-bottom: 0 !important;
}
.login__container__footer .remember_me {
  color: hsl(217, 24%, 17%);
  margin-top: 0.5em;
  margin-bottom: 0.5em;
  font-weight: 400;
}
.login__container__footer .remember_me .MuiTypography-root {
  font-size: 1em;
}
.login__container__footer .remember_me .MuiCheckbox-root {
  padding-top: 0;
  padding-bottom: 0;
}
.login__container__footer .remember_me .checkedIcon,
.login__container__footer .remember_me .uncheckedIcon {
  width: 16px;
  height: 16px;
}
.login__container__footer .remember_me .uncheckedIcon {
  fill: hsl(0, 0%, 100%);
  background: hsl(0, 0%, 100%);
  border-radius: 50%;
}
.login__container__footer .forgot_link {
  color: hsl(217, 24%, 17%);
  font-weight: 400;
}
.login__container__footer .forgot_link:first-child {
  margin-bottom: 6px;
}
.login__title-color {
  color: hsla(217, 24%, 17%, 0.788);
  margin-right: 3px;
}
.login__input {
  padding: 11px 15px;
  margin-bottom: 6px;
  width: 100%;
  border: none;
  border-radius: 10px;
  font-size: 14px;
  color: hsl(217, 24%, 17%);
  background-color: hsl(0, 0%, 100%);
}
.login__input::placeholder {
  color: hsl(217, 24%, 17%) !important;
}
.login__input:focus, .login__input:focus-within {
  box-shadow: 0 0 0.05rem 0.05rem hsl(237, 46%, 75%);
}
.login__input.error {
  box-shadow: 0 0 0.05rem 0.05rem hsl(5, 100%, 69%);
}
.login__input__error-display {
  display: block;
  color: hsl(5, 100%, 69%);
  font-size: 12px;
  margin-bottom: 9px;
  padding-left: 15px;
}
.login__input__error-display.indi {
  margin-top: -3px;
  margin-bottom: 15px;
}
.login__input__error-hide {
  display: none;
}
.login__button {
  background-color: hsl(233, 100%, 57%) !important;
  border: none;
  cursor: pointer;
  padding: 0.75em 3em;
  width: 100%;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.25px;
  color: hsl(0, 0%, 100%);
}
.login__google__btn {
  width: 100%;
  background-color: hsl(0, 0%, 100%);
  color: rgb(0, 0, 0);
  height: 45px;
  border-left: none;
  margin-left: -2px;
  border-radius: unset;
}
.login__footer {
  margin-top: 42px;
}
.login__footer__text {
  font-weight: bold;
  font-size: 18px;
  line-height: 2em;
  text-align: center;
  color: hsl(217, 24%, 17%);
  margin-bottom: 12px !important;
}
.login__footer__button {
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  text-decoration: none;
  color: hsl(217, 24%, 17%);
  letter-spacing: 0.25px;
  text-transform: capitalize;
  padding: 0.75em 3em;
  text-align: center;
  background-color: hsl(0, 0%, 95%) !important;
  border-color: hsl(0, 0%, 95%) !important;
  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}
@media screen and (max-device-width: 1200px) and (min-resolution: 100dpi) {
  .login__footer {
    margin-top: 1rem;
  }
  .login__footer__text {
    line-height: 1rem;
  }
}

.forgot-dialog .MuiPaper-root {
  background-color: #fafafa;
  border-radius: 2px;
  width: min(400px, 90vw);
}
.forgot-dialog .forget__content {
  padding: 0px 30px 13px;
}
.forgot-dialog .dialog__title {
  font-weight: bold;
  font-size: 24px;
  padding: 17px 30px 8px 30px;
}
.forgot-dialog .dialog__subtitle {
  font-size: 13px;
  color: hsla(217, 24%, 17%, 0.788);
  font-weight: 500;
  margin-bottom: 27px;
}
.forgot-dialog a {
  font-weight: bold;
  font-size: 12px;
}
.forgot-dialog .login__input__error-display.forgot {
  background-color: transparent;
  padding: 0;
  margin-top: 0px;
  margin-bottom: 9px;
  border-radius: 0;
  padding-left: 1.5em;
  color: #FE5749;
}
.forgot-dialog .login__button.forgot {
  margin-top: 20px !important;
  box-shadow: none;
  margin-bottom: 13px;
}

.forgot-dialog.success__dialog .MuiPaper-root {
  width: min(488px, 90vw);
}
.forgot-dialog.success__dialog .MuiPaper-root .success__content {
  padding-top: 29px;
  padding-bottom: 17px;
}
.forgot-dialog.success__dialog .MuiPaper-root .success__content .css-mxhe7w {
  text-align: center;
}
.forgot-dialog.success__dialog .MuiPaper-root .success__content .dialog__subtitle {
  font-size: 18px;
  text-align: center;
  font-weight: 700;
  width: 240px;
  margin: 0 auto 28px;
}
.forgot-dialog.success__dialog .MuiPaper-root .success__content .sClose__button {
  font-size: 14px;
  font-weight: 600;
  padding: 6.5px 43.5px;
  border-radius: 5px;
  background-color: hsl(233, 100%, 57%);
}`, "",{"version":3,"sources":["webpack://./src/index.scss","webpack://./src/components/login/login.scss"],"names":[],"mappings":"AAyDA;;EAEE,YAAA;ACvDF;;AD6DE;EACI,yBAAA;AC1DN;;ADyDE;EACI,yBAAA;ACtDN;;ADqDE;EACI,yBAAA;AClDN;;ADiDE;EACI,yBAAA;AC9CN;;AD6CE;EACI,yBAAA;AC1CN;;ADyCE;EACI,yBAAA;ACtCN;;ADqCE;EACI,yBAAA;AClCN;;ADiCE;EACI,yBAAA;AC9BN;;AD6BE;EACI,yBAAA;AC1BN;;ADyBE;EACI,0BAAA;ACtBN;;ADqBE;EACI,0BAAA;AClBN;;ADiBE;EACI,0BAAA;ACdN;;ADaE;EACI,0BAAA;ACVN;;ADSE;EACI,0BAAA;ACNN;;ADKE;EACI,0BAAA;ACFN;;ADCE;EACI,0BAAA;ACEN;;ADHE;EACI,0BAAA;ACMN;;ADPE;EACI,0BAAA;ACUN;;ADXE;EACI,0BAAA;ACcN;;ADfE;EACI,0BAAA;ACkBN;;ADnBE;EACI,0BAAA;ACsBN;;ADvBE;EACI,0BAAA;AC0BN;;AD3BE;EACI,0BAAA;AC8BN;;AD/BE;EACI,0BAAA;ACkCN;;ADnCE;EACI,0BAAA;ACsCN;;ADvCE;EACI,0BAAA;AC0CN;;AD3CE;EACI,0BAAA;AC8CN;;AD/CE;EACI,0BAAA;ACkDN;;ADnDE;EACI,0BAAA;ACsDN;;ADvDE;EACI,0BAAA;AC0DN;;AD3DE;EACI,0BAAA;AC8DN;;AD/DE;EACI,0BAAA;ACkEN;;ADnEE;EACI,0BAAA;ACsEN;;ADvEE;EACI,0BAAA;AC0EN;;AD3EE;EACI,0BAAA;AC8EN;;AD/EE;EACI,0BAAA;ACkFN;;ADnFE;EACI,0BAAA;ACsFN;;ADvFE;EACI,0BAAA;AC0FN;;AD3FE;EACI,0BAAA;AC8FN;;AD/FE;EACI,0BAAA;ACkGN;;ADnGE;EACI,0BAAA;ACsGN;;ADvGE;EACI,0BAAA;AC0GN;;AD3GE;EACI,0BAAA;AC8GN;;AD/GE;EACI,0BAAA;ACkHN;;ADnHE;EACI,0BAAA;ACsHN;;ADvHE;EACI,0BAAA;AC0HN;;AD3HE;EACI,0BAAA;AC8HN;;AD/HE;EACI,0BAAA;ACkIN;;ADnIE;EACI,0BAAA;ACsIN;;ADvIE;EACI,0BAAA;AC0IN;;AD3IE;EACI,0BAAA;AC8IN;;AD/IE;EACI,0BAAA;ACkJN;;ADnJE;EACI,0BAAA;ACsJN;;ADvJE;EACI,0BAAA;AC0JN;;AD3JE;EACI,0BAAA;AC8JN;;AD/JE;EACI,0BAAA;ACkKN;;ADnKE;EACI,0BAAA;ACsKN;;ADvKE;EACI,0BAAA;AC0KN;;AD3KE;EACI,0BAAA;AC8KN;;AD/KE;EACI,0BAAA;ACkLN;;ADnLE;EACI,0BAAA;ACsLN;;ADvLE;EACI,0BAAA;AC0LN;;AD3LE;EACI,0BAAA;AC8LN;;AD/LE;EACI,0BAAA;ACkMN;;ADnME;EACI,0BAAA;ACsMN;;ADvME;EACI,0BAAA;AC0MN;;AD3ME;EACI,0BAAA;AC8MN;;AD/ME;EACI,0BAAA;ACkNN;;ADnNE;EACI,0BAAA;ACsNN;;ADvNE;EACI,0BAAA;AC0NN;;AD3NE;EACI,0BAAA;AC8NN;;AD/NE;EACI,0BAAA;ACkON;;ADnOE;EACI,0BAAA;ACsON;;ADvOE;EACI,0BAAA;AC0ON;;AD3OE;EACI,0BAAA;AC8ON;;AD/OE;EACI,0BAAA;ACkPN;;ADnPE;EACI,0BAAA;ACsPN;;ADvPE;EACI,0BAAA;AC0PN;;AD3PE;EACI,0BAAA;AC8PN;;AD/PE;EACI,0BAAA;ACkQN;;ADnQE;EACI,0BAAA;ACsQN;;ADvQE;EACI,0BAAA;AC0QN;;AD3QE;EACI,0BAAA;AC8QN;;AD/QE;EACI,0BAAA;ACkRN;;ADnRE;EACI,0BAAA;ACsRN;;ADvRE;EACI,0BAAA;AC0RN;;AD3RE;EACI,0BAAA;AC8RN;;AD/RE;EACI,0BAAA;ACkSN;;ADnSE;EACI,0BAAA;ACsSN;;ADvSE;EACI,0BAAA;AC0SN;;AD3SE;EACI,0BAAA;AC8SN;;AD/SE;EACI,0BAAA;ACkTN;;ADnTE;EACI,0BAAA;ACsTN;;ADvTE;EACI,0BAAA;AC0TN;;AD3TE;EACI,0BAAA;AC8TN;;AD/TE;EACI,0BAAA;ACkUN;;ADnUE;EACI,0BAAA;ACsUN;;ADvUE;EACI,0BAAA;AC0UN;;AD3UE;EACI,0BAAA;AC8UN;;AD/UE;EACI,2BAAA;ACkVN;;AD9UA;EACE,SAAA;EACA,gCAAA;EACA,mCAAA;EACA,kCAAA;EACA,4CAAA;EACA,oCAAA;ACiVF;;AD9UA;EACE,yBA9Ca;AC+Xf;AD/UE;EAEE,yBAnDW;ACmYf;AD7UE;EACE,qBAAA;AC+UJ;;AD3UA;EACE,eAAA;AC8UF;;AAzaA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,iBAAA;EACA,uBAAA;EACA,oBAAA;AA4aF;AA1aE;EACE,kBAAA;EACA,MAAA;EACA,UAAA;EACA,iBAAA;EACA,6BAAA;EACA,wBDqBW;ECpBX,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,cAAA;AA4aJ;AAzaE;EACE,cAAA;EAEA,WAAA;AA0aJ;AAxaM;EACE,oCAAA;EACA,UAAA;AA0aR;AAraE;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;AAuaJ;AAraI;EANF;IAOI,qBAAA;EAwaJ;AACF;AAraE;EACE,eAAA;EACA,iCDvBW;ECwBX,iBAAA;AAuaJ;AApaE;EACE,yCDvCY;ECwCZ,2CAAA;EACA,uBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAsaJ;AApaI;EARF;IASI,oBAAA;EAuaJ;AACF;AAraI;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,2GAAA;EACA,gBAAA;EACA,uBAAA;EACA,cAAA;AAuaN;AAraM;EACE,kCDxDQ;ECyDR,UAAA;AAuaR;AAnaI;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,kCDpEU;ECqEV,eAAA;EACA,gBAAA;AAqaN;AAnaM;EACE,eAAA;EACA,aAAA;EACA,eAAA;AAqaR;AAlaM;EACE,eAAA;AAoaR;AAhaI;EACE,yBD9ES;EC+ET,gCAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AAkaN;AAhaM;EAEE,WAAA;EACA,iDAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;AAiaR;AA9ZM;EACE,OAAA;AAgaR;AA7ZM;EACE,QAAA;AA+ZR;AA5ZM;EAzBF;IA0BI,gBAAA;IACA,eAAA;EA+ZN;AACF;AA5ZI;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;AA8ZN;AA7ZM;EARF;IASI,sBAAA;EAgaN;AACF;AA9ZM;EACE,2BAAA;AAgaR;AA7ZM;EACE,yBD7HO;EC8HP,iBAAA;EACA,oBAAA;EACA,gBAAA;AA+ZR;AA7ZQ;EACE,cAAA;AA+ZV;AA5ZQ;EACE,cAAA;EACA,iBAAA;AA8ZV;AA3ZQ;;EAEE,WAAA;EACA,YAAA;AA6ZV;AA1ZQ;EACE,sBDxJM;ECyJN,4BDzJM;EC0JN,kBAAA;AA4ZV;AAxZM;EACE,yBDzJO;EC0JP,gBAAA;AA0ZR;AAzZQ;EACE,kBAAA;AA2ZV;AArZE;EACE,iCDlKW;ECmKX,iBAAA;AAuZJ;AApZE;EACE,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,yBD9KW;EC+KX,kCDrLY;AC2kBhB;AAnZI;EACE,oCAAA;AAqZN;AAlZI;EAEE,kDAAA;AAmZN;AAhZI;EACE,iDAAA;AAkZN;AA/YI;EACE,cAAA;EACA,wBDtNW;ECuNX,eAAA;EACA,kBAAA;EACA,kBAAA;AAiZN;AAhZM;EACE,gBAAA;EACA,mBAAA;AAkZR;AA9YI;EACE,aAAA;AAgZN;AA3YE;EACE,gDAAA;EAEA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,uBDlOY;AC8mBhB;AAzYE;EACE,WAAA;EACA,kCDvOY;ECwOZ,mBDvOQ;ECwOR,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,oBAAA;AA2YJ;AAxYE;EACE,gBAAA;AA0YJ;AAxYI;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBDjPS;ECkPT,8BAAA;AA0YN;AAvYI;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,yBD1PS;EC2PT,sBAAA;EACA,0BAAA;EACA,mBAAA;EACA,kBAAA;EACA,4CAAA;EACA,wCAAA;EACA,0CAAA;EACA,kBAAA;AAyYN;AAtYI;EA5BF;IA6BI,gBAAA;EAyYJ;EAvYI;IACE,iBAAA;EAyYN;AACF;;AAnYE;EACE,yBAAA;EACA,kBAAA;EACA,uBAAA;AAsYJ;AAnYE;EACE,sBAAA;AAqYJ;AAlYE;EACE,iBAAA;EACA,eAAA;EACA,2BAAA;AAoYJ;AAjYE;EACE,eAAA;EACA,iCDjSW;ECkSX,gBAAA;EACA,mBAAA;AAmYJ;AAhYE;EACE,iBAAA;EACA,eAAA;AAkYJ;AA9XE;EACE,6BAAA;EACA,UAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AAgYJ;AA7XE;EACE,2BAAA;EACA,gBAAA;EACA,mBAAA;AA+XJ;;AA1XE;EACE,uBAAA;AA6XJ;AA5XI;EACE,iBAAA;EACA,oBAAA;AA8XN;AA7XM;EACE,kBAAA;AA+XR;AA7XM;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;AA+XR;AA7XM;EACE,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,qCDpWU;ACmuBlB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap');\n$clr-danger-900: hsla(0, 89%, 48%, 0.19);\n$clr-danger-450: hsla(5, 99%, 64%, 1);\n$clr-danger-400: hsla(5, 100%, 69%, 1);\n$clr-danger-200: hsla(0, 48%, 83%, 1);\n$clr-primary-900: hsla(237, 69%, 40%, 1);\n$clr-primary-700: hsla(237, 69%, 52%, 1);\n$clr-primary-600: hsla(233, 100%, 57%, 1);\n$clr-primary-400: hsla(237, 40%, 67%, 1);\n$clr-primary-300: hsla(237, 46%, 75%, 1);\n$clr-light-350: hsla(0, 0%, 77%, 0.44);\n$clr-light-450: hsla(0, 0%, 85%, 1);\n$clr-light-500: hsla(0, 0%, 88%, 1);\n$clr-light-600: hsla(0, 0%, 92%, 1);\n$clr-light-700: hsla(0, 0%, 100%, 0.43);\n$clr-light-800: hsla(0, 0%, 98%, 0.83);\n$clr-light-850: hsla(0, 0%, 100%, 0.85);\n$clr-light-95: hsla(0, 0%, 95%, 1);\n$clr-light-900: hsla(0, 0%, 100%, 1);\n$clr-black: rgba(0, 0, 0, 1);\n$clr-black-900: hsla(217, 31%, 6%, 1);\n$clr-black-850: hsla(240, 50%, 4%, 0.69);\n$clr-black-500: hsla(217, 31%, 6%, 0.21);\n$clr-black-25: rgba(0, 0, 0, 0.25);\n$clr-dark-900: hsla(217, 24%, 17%, 1);\n$clr-dark-700: hsla(217, 24%, 17%, 0.788);\n$clr-dark-650: hsla(217, 24%, 17%, 0.35);\n$clr-dark-600: hsla(214, 4%, 39%, 1);\n$clr-dark-630: hsla(214, 4%, 39%, 0.63);\n$clr-dark-500: hsla(217, 1%, 50%, 1);\n$clr-dark-450: hsla(210, 1%, 50%, 1);\n$clr-dark-400: hsla(0, 0%, 97%, 0.78);\n$clr-dark-350: hsla(240, 22%, 95%, 0.22);\n$clr-link-900: hsla(240, 91%, 69%, 1);\n$clr-link-700: hsla(240, 91%, 69%, 1);\n$clr-success-400: hsla(113, 49%, 55%, 0.34);\n\n$clr-dark-300: hsla(214, 4%, 31%, 1);\n$clr-dark-250: hsla(180, 20%, 17%, 1);\n$clr-dark-200: hsla(223, 4%, 66%, 1);\n$clr-dark-150: hsla(217, 24%, 17%, 0.79);\n$clr-light-10: hsla(0, 0%, 71%, 1);\n$clr-light-15: hsla(0, 0%, 92%, 0.69);\n$clr-light-20: hsla(214, 4%, 31%, 0.8);\n$clr-light-25: hsla(0, 0%, 77%, 1);\n$clr-light-30: hsla(0, 0%, 98%, 1);\n$clr-light-35: hsla(0, 0%, 75%, 0.28);\n$clr-light-40: hsla(214, 4%, 31%, 0.79);\n$clr-primary-10: hsla(234, 95%, 92%, 0.37);\n$clr-primary-20: hsla(234, 95%, 92%, 1);\n$clr-link-600: hsla(234, 92%, 56%, 1);\n$clr-success: hsla(217, 24%, 17%, 0.93);\n$clr-table: hsla(213, 7%, 76%, 0.08);\n\n\n\n\nhtml,\nbody {\n  height: 100%;\n}\n\n@for $i from 1 through 100 {\n  $size: 1px * $i;\n\n  .font-size-#{$i} {\n      font-size: $size !important;\n  }\n}\n\nbody {\n  margin: 0;\n  font-family: 'roboto' !important;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: $clr-light-600 !important;\n  color: $clr-dark-900 !important;\n}\n\na {\n  color: $clr-link-700;\n\n  &:hover,\n  &:focus {\n    color: $clr-link-900;\n  }\n\n  &.no-underline {\n    text-decoration: none;\n  }\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}","@import '../../index.scss';\n\n.login {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  min-height: 100vh;\n  justify-content: center;\n  padding-bottom: 2rem;\n\n  &__header {\n    position: absolute;\n    top: 0;\n    left: 32px;\n    line-height: 72px;\n    background-color: transparent;\n    color: $clr-dark-300;\n    font-weight: 400;\n    font-size: 24px;\n    letter-spacing: 0.05em;\n    color: #4C4F53;\n  }\n\n  form {\n    margin: 0 auto;\n    // max-width: 320px;\n    width: 100%;\n    .login__input{\n      input#password::placeholder{\n        color: $clr-dark-900 !important;\n        opacity: 1;\n      }\n    }\n  }\n\n  &__title {\n    display: flex;\n    margin: 19px 0;\n    align-items: center;\n    justify-content: center;\n\n    @media screen and (max-device-width: 1200px) and (min-resolution: 100dpi) {\n      margin-bottom: 0.5rem;\n    }\n  }\n\n  &__title-text {\n    font-size: 24px;\n    color: $clr-dark-700;\n    font-weight: bold;\n  }\n\n  &__container {\n    background-color: $clr-light-700;\n    box-shadow: 0px 4px 4px $clr-black-25;\n    width: Min(407px, 90vw);\n    padding: 27px 38px 31px;\n    border-radius: 20px;\n    position: relative;\n\n    @media screen and (max-device-width: 1200px) and (min-resolution: 100dpi) {\n      padding: 1rem 1.5rem;\n    }\n\n    .linear_progress {\n      position: absolute;\n      top: 0;\n      left: 0;\n      background-image: linear-gradient(89.91deg, rgba(220, 34, 255, 0.5) 12.07%, rgba(57, 161, 244, 0.5) 89.16%);\n      margin-left: 1em;\n      width: calc(100% - 2em);\n      height: 0.15em;\n\n      .MuiLinearProgress-bar {\n        background-color: $clr-light-900;\n        width: 2em;\n      }\n    }\n\n    &__title {\n      display: flex;\n      align-items: center;\n      padding: 4px 8px;\n      line-height: 45px;\n      border-radius: 10px;\n      font-size: 14px;\n      background-color: $clr-light-900;\n      cursor: pointer;\n      font-weight: 500;\n\n      &__google {\n        font-size: 40px;\n        display: flex;\n        flex-basis: 35%;\n      }\n\n      &__text {\n        flex-basis: 75%;\n      }\n    }\n\n    &__divider {\n      color: $clr-dark-900;\n      padding: 30px 1.5rem 35px 1.5rem;\n      position: relative;\n      text-align: center;\n      font-size: 14px;\n\n      &::after,\n      &::before {\n        content: '';\n        border-top: 2px solid $clr-light-900 !important;\n        position: absolute;\n        width: 40%;\n        top: 50%;\n        transform: translateY(-50%);\n      }\n\n      &::before {\n        left: 0;\n      }\n\n      &::after {\n        right: 0;\n      }\n\n      @media screen and (max-device-width: 1200px) and (min-resolution: 100dpi) {\n        padding: 0.25rem;\n        font-size: 14px;\n      }\n    }\n\n    &__footer {\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      align-items: center;\n      margin-top: 11px;\n      margin-bottom: 19px;\n      font-size: 12px;\n      @media screen and (max-device-width: 1200px) and (min-resolution: 100dpi) {\n        margin-bottom: 0.25rem;\n      }\n\n      &.forgot {\n        margin-bottom: 0 !important;\n      }\n\n      .remember_me {\n        color: $clr-dark-900;\n        margin-top: 0.5em;\n        margin-bottom: 0.5em;\n        font-weight: 400;\n\n        .MuiTypography-root {\n          font-size: 01em;\n        }\n\n        .MuiCheckbox-root {\n          padding-top: 0;\n          padding-bottom: 0;\n        }\n\n        .checkedIcon,\n        .uncheckedIcon {\n          width: 16px;\n          height: 16px;\n        }\n\n        .uncheckedIcon {\n          fill: $clr-light-900;\n          background: $clr-light-900;\n          border-radius: 50%;\n        }\n      }\n\n      .forgot_link {\n        color: $clr-dark-900;\n        font-weight: 400;\n        &:first-child{\n          margin-bottom: 6px;\n        }\n      }\n    }\n  }\n\n  &__title-color {\n    color: $clr-dark-700;\n    margin-right: 3px;\n  }\n\n  &__input {\n    padding: 11px 15px;\n    margin-bottom: 6px;\n    width: 100%;\n    border: none;\n    border-radius: 10px;\n    font-size: 14px;\n    color: $clr-dark-900;\n    background-color: $clr-light-900;\n    \n\n    &::placeholder{\n      color: $clr-dark-900 !important;\n    }\n\n    &:focus, \n    &:focus-within {\n      box-shadow: 0 0 0.05rem 0.05rem $clr-primary-300;\n    }\n\n    &.error {\n      box-shadow: 0 0 0.05rem 0.05rem $clr-danger-400;\n    }\n\n    &__error-display {\n      display: block;\n      color: $clr-danger-400;\n      font-size: 12px;\n      margin-bottom: 9px;\n      padding-left: 15px;\n      &.indi{\n        margin-top: -3px;\n        margin-bottom: 15px;\n      }\n    }\n\n    &__error-hide {\n      display: none;\n    }\n  }\n\n  //todo: move all colors to global scss file\n  &__button {\n    background-color: $clr-primary-600 !important;\n    // box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.2), 0px 1px 18px rgba(0, 0, 0, 0.12), 0px 6px 10px rgba(0, 0, 0, 0.14);\n    border: none;\n    cursor: pointer;\n    padding: 0.75em 3em;\n    width: 100%;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 16px;\n    letter-spacing: 0.25px;\n    color: $clr-light-900;\n  }\n\n  &__google__btn {\n    width: 100%;\n    background-color: $clr-light-900;\n    color: $clr-black;\n    height: 45px;\n    border-left: none;\n    margin-left: -2px;\n    border-radius: unset;\n  }\n\n  &__footer {\n    margin-top: 42px;\n\n    &__text {\n      font-weight: bold;\n      font-size: 18px;\n      line-height: 2em;\n      text-align: center;\n      color: $clr-dark-900;\n      margin-bottom: 12px !important;\n    }\n\n    &__button {\n      font-weight: 500;\n      font-size: 14px;\n      line-height: 16px;\n      text-decoration: none;\n      color: $clr-dark-900;\n      letter-spacing: 0.25px;\n      text-transform: capitalize;\n      padding: 0.75em 3em;\n      text-align: center;\n      background-color: $clr-light-95 !important;\n      border-color: $clr-light-95 !important;\n      box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.2);\n      border-radius: 4px;\n    }\n\n    @media screen and (max-device-width: 1200px) and (min-resolution: 100dpi) {\n      margin-top: 1rem;\n\n      &__text {\n        line-height: 1rem;\n      }\n    }\n  }\n}\n\n.forgot-dialog {\n  .MuiPaper-root {\n    background-color: #fafafa;\n    border-radius: 2px;\n    width: Min(400px, 90vw);\n  }\n\n  .forget__content{\n    padding: 0px 30px 13px;\n  }\n\n  .dialog__title {\n    font-weight: bold;\n    font-size: 24px;\n    padding: 17px 30px 8px 30px;\n  }\n\n  .dialog__subtitle {\n    font-size: 13px;\n    color: $clr-dark-700;\n    font-weight: 500;\n    margin-bottom: 27px;\n  }\n\n  a {\n    font-weight: bold;\n    font-size: 12px;\n\n  }\n\n  .login__input__error-display.forgot{\n    background-color: transparent;\n    padding: 0;\n    margin-top: 0px;\n    margin-bottom: 9px;\n    border-radius: 0;\n    padding-left: 1.5em;\n    color: #FE5749;\n  }\n\n  .login__button.forgot{\n    margin-top: 20px !important;\n    box-shadow: none;\n    margin-bottom: 13px;\n  }\n}\n\n.forgot-dialog.success__dialog{\n  .MuiPaper-root{\n    width: Min(488px, 90vw);\n    .success__content{\n      padding-top: 29px;\n      padding-bottom: 17px;\n      .css-mxhe7w{\n        text-align: center;\n      }\n      .dialog__subtitle{\n        font-size: 18px;\n        text-align: center;\n        font-weight: 700;\n        width: 240px;\n        margin: 0 auto 28px;\n      }\n      .sClose__button{\n        font-size: 14px;\n        font-weight: 600;\n        padding: 6.5px 43.5px;\n        border-radius: 5px;\n        background-color: $clr-primary-600;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
